<template>
  <div class="theme-hero-area">
    <div class="theme-hero-area-bg-wrap">
      <div
          class="theme-hero-area-bg"
          :style="{'background-image': 'url(' + require('@/assets/img/bg-home-hero.jpg') + ')'}"></div>
      <div class="theme-hero-area-bg theme-hero-grad-mask"></div>
    </div>
    <div class="theme-hero-area-body">
      <div class="theme-page-section">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-md-offset-3">
              <div class="theme-login-header">
                <router-link to="/login">
                  <span class="center-block mt-30 _mb-50">
                    <img
                        class="img-responsive"
                        src="@/assets/img/logo-experience.png"
                        alt="Logo Tour House"
                        title="Tour House">
                  </span>
                </router-link>
              </div>
            </div>
            <!-- cookies  -->
            <div class="cookie" :class="containerPosition" v-if="isOpen">
              <div class="cookie__content">
                <slot name="message">Este site usa cookies para melhorar a sua experiência de navegação, para saber mais
                  por favor consulte os nossos
                  <a href="/TermsConditions">Termos de serviço</a> e
                  <a href="/PoliciesPrivacy">Politica de privacidade</a>
                </slot>
              </div>
              <div class="cookie__button accept" @click="accept">
                {{ buttonTextAccept }}
              </div>
            </div>
            <!-- end cookies -->
            <div class="col-md-6 col-md-offset-3">
              <div class="theme-login theme-login-white">
                <div class="theme-login-box">
                  <div class="theme-login-box-inner">
                    <div class="col-md-12">
                      <form
                          v-if="step === 'credentials'"
                          @submit.prevent="handleSubmit"
                          class="theme-login-form">
                        <div class="form-group theme-login-form-group">
                          <input
                              class="form-control"
                              type="text"
                              placeholder="Endereço de e-mail"
                              name="username"
                              v-model="username"
                              v-validate="'required'"
                              :class="{'alert-danger': errors.has('username')}">
                          <span class="error-message-forms">{{ errors.first('username') }}</span>
                        </div>
                        <div class="form-group theme-login-form-group">
                          <input
                              class="form-control"
                              type="password"
                              placeholder="Senha"
                              name="password"
                              v-model="password"
                              v-validate="'required'"
                              :class="{'alert-danger': errors.has('password')}">
                          <span class="error-message-forms">{{ errors.first('password') }}</span>
                          <p class="help-block">
                            <router-link to="/forgot_password">
                              <a>Esqueceu sua senha?</a>
                            </router-link>
                          </p>
                        </div>
                        <button
                            type="submit"
                            class="btn btn-uc btn-dark btn-block btn-lg"
                            href="#"
                            :disabled="loading">
                          <i class="fa fa-sign-in" aria-hidden="true"></i>
                          Entrar
                        </button>
                      </form>

                      <form
                          v-else
                          @submit.prevent="handleSubmitCode"
                          class="theme-login-form">
                        <p class="text-center _mb-20">
                          Enviamos um código de acesso para
                          <strong>{{ maskedRecipient }}</strong>.
                          Insira-o abaixo para concluir o login.
                        </p>
                        <div class="form-group theme-login-form-group">
                          <otp-input
                              ref="otpInput"
                              v-model="code"
                              :disabled="loading"
                              :has-error="codeError !== ''"
                              :error-message="codeError"
                              @complete="handleSubmitCode" />
                        </div>
                        <button
                            type="submit"
                            class="btn btn-uc btn-dark btn-block btn-lg"
                            :disabled="loading || code.length !== 6">
                          Confirmar
                        </button>
                        <resend-countdown
                            :initial="resendAvailableIn"
                            :disabled="loading"
                            @resend="handleResend" />
                        <p class="help-block text-center _mt-10">
                          <a href="#" @click.prevent="backToCredentials">
                            Voltar e usar outra conta
                          </a>
                        </p>
                      </form>
                    </div>
                    <div class="col-md-12 disclaimers _mb-20" style="text-align:center;">
                      <small>Esse site é protegido por reCAPTCHA e Google onde<br><a
                          href="https://etripx.com.br/PoliciesPrivacy/">Politica de privacidade</a> e <a
                          href="https://etripx.com.br/TermsConditions/">Termos de serviço</a> se aplicam.</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import OtpInput from '@/components/auth/OtpInput.vue';
import ResendCountdown from '@/components/auth/ResendCountdown.vue';

export default {
  components: { OtpInput, ResendCountdown },
  props: {
    buttonTextAccept: {
      type: String,
      default: "Aceitar",
    },
    buttonTextDeny: {
      type: String,
      default: "Recusar",
    },
    position: {
      type: String,
      default: "bottom",
    },
  },
  data() {
    return {
      step: 'credentials',
      username: '',
      password: '',
      code: '',
      codeError: '',
      challengeId: '',
      maskedRecipient: '',
      expiresInSeconds: 0,
      resendAvailableIn: 0,
      message: '',
      loading: false,
      isOpen: false,
    };
  },
  computed: {
    containerPosition() {
      return `cookie--${this.position}`;
    },
  },

  methods: {
    accept() {
      this.isOpen = false;
      return localStorage.setItem("ExCookie", true);
    },
    getCookieAccept() {
      return localStorage.getItem("ExCookie", true);
    },
    ...mapActions('auth', [
      'postUserLogin',
      'postLoginVerify',
      'postLoginResend',
    ]),

    ...mapActions('user', [
      'getVerify',
      'postRequestInvite'
    ]),

    ...mapActions('notification', {
      notify: 'show',
    }),

    /**
     * Render a credential-step error. The ``is_active === false`` path
     * still belongs to the signup-activation legacy flow and offers to
     * resend the original confirmation link; every other failure ends
     * the loading state and shows the server's message verbatim.
     */
    handleError(error) {
      this.loading = false;
      if (error.response.data.is_active === false) {
        this.$swal({
          title: 'Confirme seu usuário pelo link enviado ao seu e-mail, caso queira enviar outro link clique no botão abaixo.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Enviar',
          cancelButtonText: 'Cancelar',
        }).then(result => {
          if (result.value) {
            this.handleSubmitRequestInvite()
          }
        })
      } else {
        this.$swal({
          title: error.response.data.message || 'Ocorreu um erro ao realizar login. Tente novamente.',
          type: error.response.data.info ? "info" : "error",
          confirmButtonText: "SAIR"
        })
      }
    },

    /**
     * Move into the OTP-entry step with the fresh challenge envelope.
     * Focusing the input here saves the user a tap and lets browser
     * one-time-code autofill find the field immediately.
     */
    enterOtpStep(otp) {
      this.challengeId = otp.challenge_id;
      this.maskedRecipient = otp.masked_recipient || '';
      this.expiresInSeconds = otp.expires_in_seconds || 0;
      this.resendAvailableIn = otp.resend_available_in_seconds || 0;
      this.code = '';
      this.codeError = '';
      this.step = 'otp';
      this.$nextTick(() => {
        if (this.$refs.otpInput) {
          this.$refs.otpInput.focus();
        }
      });
    },

    /**
     * Hand the user back to the credentials form, discarding any
     * in-flight OTP. The challenge is intentionally NOT consumed --
     * it will expire naturally on the server.
     */
    backToCredentials() {
      this.step = 'credentials';
      this.challengeId = '';
      this.code = '';
      this.codeError = '';
      this.loading = false;
    },

    handleLogin(token = false) {
      this.postUserLogin({
        username: this.username,
        password: this.password,
        token
      }).then(response => {
        const data = response.data || {};
        if (data.error) {
          this.loading = false;
          return;
        }
        if (data.user) {
          // Bypass / legacy shape -- session is already bound by the store.
          this.$ga.event({
            eventCategory: 'Authentication',
            eventAction: 'Login',
            eventLabel: 'Login',
            eventValue: 1
          });
          if (data.user.password_expired) {
            this.$router.push('/password_change');
          } else {
            this.$router.push('/');
          }
          return;
        }
        if (data.otp) {
          this.loading = false;
          this.enterOtpStep(data.otp);
        }
      }).catch(error => this.handleError(error))
    },

    handleSubmit() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.loading = true;
          this.$recaptcha('login')
              .then((token) => this.handleLogin(token))
              .catch(error => {
                if (process.env.NODE_ENV === 'development') {
                  this.handleLogin()
                } else {
                  console.log('recaptcha', error)
                  this.loading = false
                }
              });
        }
      })
    },

    /**
     * Step 2 submit. Server replies with the legacy ``{user:...}``
     * shape on success and ``{error:..., remaining_attempts:...}`` on
     * failure -- callers must NOT trust ``response.status`` alone
     * because the SPA's axios baseline returns 200 for some failures.
     */
    handleSubmitCode() {
      if (this.code.length !== 6 || this.loading) {
        return;
      }
      this.loading = true;
      this.codeError = '';
      this.postLoginVerify({
        challenge_id: this.challengeId,
        code: this.code,
      }).then(response => {
        const data = response.data || {};
        if (data.error || !data.user) {
          this.loading = false;
          this.codeError = data.message || 'Código inválido.';
          return;
        }
        this.$ga.event({
          eventCategory: 'Authentication',
          eventAction: 'Login',
          eventLabel: 'Login',
          eventValue: 1
        });
        if (data.user.password_expired) {
          this.$router.push('/password_change');
        } else {
          this.$router.push('/');
        }
      }).catch(error => {
        this.loading = false;
        const data = (error.response && error.response.data) || {};
        this.codeError = data.message || 'Código inválido.';
        // When the OTP itself is locked out the user must restart.
        if (data.remaining_attempts === 0) {
          this.$swal({
            title: this.codeError,
            type: 'warning',
            confirmButtonText: 'OK',
          }).then(() => this.backToCredentials());
          return;
        }
        // Wrong code but the OTP is still alive: clear the field and
        // refocus so the next attempt is one tap away. ``maxlength=6``
        // would otherwise block the user from typing over the stale
        // value without manual delete.
        this.code = '';
        this.$nextTick(() => {
          if (this.$refs.otpInput) {
            this.$refs.otpInput.focus();
          }
        });
      });
    },

    handleResend() {
      if (this.loading || !this.challengeId) {
        return;
      }
      this.loading = true;
      this.postLoginResend({
        challenge_id: this.challengeId,
      }).then(response => {
        this.loading = false;
        const data = response.data || {};
        if (data.error) {
          this.notify({ message: data.message || 'Falha ao reenviar.', kind: 'error' });
          return;
        }
        if (data.otp) {
          this.enterOtpStep(data.otp);
          this.notify({
            message: 'Enviamos um novo código para ' + (data.otp.masked_recipient || 'seu e-mail') + '.',
            kind: 'success',
          });
        }
      }).catch(error => {
        this.loading = false;
        const data = (error.response && error.response.data) || {};
        this.notify({ message: data.message || 'Falha ao reenviar.', kind: 'error' });
      });
    },

    handleRequestInvite(token = false) {
      this.postRequestInvite({
        username: this.username,
        password: this.password,
        token
      }).then(response => {
        if (!response.data.error) {
          if (!response.data.error) {
            this.$swal({
              title: 'E-mail enviado com sucesso!',
              type: 'success',
              confirmButtonText: 'Fechar',
            })
          } else {
            new Error(response.data);
          }
        }
        this.loading = false;
      }).catch(error => this.handleError(error))
    },

    handleSubmitRequestInvite() {
      this.loading = true;
      this.$recaptcha('login')
          .then((token) => this.handleRequestInvite(token))
          .catch(error => {
            if (process.env.NODE_ENV === 'development') {
              this.handleRequestInvite()
            } else {
              console.log('recaptcha', error)
              this.loading = false
            }
          });
    },

    sendMessage(message, type) {
      this.$swal({
        title: message,
        type: type,
        confirmButtonText: "SAIR"
      });
    }
  },

  created() {
    if (this.$route.query.activate) {
      this.getVerify(this.$route.query.activate)
          .then(() => this.sendMessage('Conta verificada com sucesso! Faça seu login', 'success'))
          .catch(() => this.sendMessage('Token expirado ou inexistente!', 'warning'))
    }

    {
      if (!this.getCookieAccept() === true) {
        this.isOpen = true;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/views/Login';

.cookie {
  position: absolute;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 0.9fr;
  width: 1240px;
  top: 900px;
  border-radius: 7px;
  grid-gap: 10px;
  left: 18%;
  background: #f2f2f2;
}

.cookie__content {
  grid-column: auto / span 5;
  padding: 20px;
  text-align: center;
}

.cookie__button {
  align-self: center;
  margin: 10px 0;
  width: 160px;
  grid-column: auto / span 1;
}

.cookie__button.accept {
  padding: 7px;
  background: #20386e;
  color: #ffffff;
  cursor: pointer;
  border-radius: 5px;
  text-align: center;
}

.cookie__button.cookie__button.accept:hover {
  background: #42b955;
}

</style>
